module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"retry":"Retry...","validate-email":"Validating your email"},"fr_FR":{"retry":"Réessayer...","validate-email":"Validation de votre email..."}}')
  delete Component.options._Ctor
}
